import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const getNonTokenizedCardWithError = createSelector(
    creditCardsState,
    (creditCards) => creditCards.data?.find((card) => card.Id === null && card.Token === null && card.ValidationStatus === 'error') || null,
);
